module.exports = __webpack_public_path__ + "static/media/prayer.ad1b7f6f.jpg";